import React from 'react';
import { TextField, InputLabel } from '@mui/material';

interface DatePickerProps {
    id: string;
    name: string;
    value: string;
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    title?: string;
    label?: string;
    minDate?: Date;
    maxDate?: Date;
    labelMargin?: any;
    error?: boolean;
    helperText?: string;
    fullWidth?: boolean;
    width?: string; // Added to let you control width easily on other pages
}

const DatePicker: React.FC<DatePickerProps> = ({
    id,
    name,
    value,
    title,
    label,
    onChange,
    minDate,
    maxDate,
    labelMargin,
    error,
    helperText,
    fullWidth = true, // Defaults to true for your modals
    width: customWidth
}) => {
    const minDateString = minDate ? minDate.toISOString().split('T')[0] : undefined;
    const maxDateString = maxDate ? maxDate.toISOString().split('T')[0] : undefined;
    
    // Uses customWidth if provided, otherwise checks fullWidth, otherwise fallbacks
    let inputWidth = customWidth || (fullWidth ? '100%' : '150px');
    let marginLeft = '0px';
    let marginRight = '16px';

    // Legacy ID-based width rules (skipped if customWidth is explicitly passed)
    if(id === 'regDate' && !customWidth){
        inputWidth = fullWidth ? '100%' : '240px';
    }
    else if (id === 'registrationDate' && !customWidth){
        inputWidth = fullWidth ? '100%' : '200px';
        marginRight = '0px';
    }
    else if(id === 'regiDate' && !customWidth){
        inputWidth = fullWidth ? '100%' : '225px';
        marginRight='0px';
    }

    return (
        <div style={{ display: 'flex', alignItems: 'center', marginRight: marginRight, marginLeft: marginLeft, width: fullWidth ? '100%' : 'auto' }}>
            {/* Renders external text ONLY if title is passed */}
            {title && (
                <InputLabel htmlFor={id} style={{ marginRight: labelMargin || '8px', color: 'black' }}>
                    {title}
                </InputLabel>
            )}
            <TextField
                type="date"
                id={id}
                label={label} // Renders INSIDE the box as placeholder/label
                name={name}
                value={value}
                onChange={onChange}
                variant="outlined"
                style={{ backgroundColor: 'white', width: inputWidth, height: '40px' }}
                InputProps={{
                    style: { height: '40px' }
                }}
                InputLabelProps={{
                    shrink: true,
                }}
                inputProps={{
                    ...(minDateString && { min: minDateString }),
                    ...(maxDateString && { max: maxDateString })
                }}
                error={error}
                helperText={helperText}
            />
        </div>
    );
};
 
export default DatePicker;